module.exports = __webpack_public_path__ + "components/wind-icon/static/W@2x-3d895c38a7a2bebce010ef8f62dbe4e5.png";